(function () {
  /* ========= Helpers ========= */

  // Initialize all widgets found on the page/drawer
  function initAll() {
    document.querySelectorAll('.qty-discount-widget').forEach(initOne);
  }

  // Build a money formatter using shop.money_format (from data attr) or Shopify.formatMoney
  function makeFormatter(widget) {
    const fmt = widget.getAttribute('data-money-format'); // e.g. "${{amount}}"
    return function formatMoney(cents) {
      const c = Math.round(cents || 0);
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        try { return Shopify.formatMoney(c, fmt || "${{amount}}"); } catch (e) {}
      }
      // Fallback: use browser locale currency if Shopify helper absent
      return (c / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
    };
  }

  /* ========= One widget instance ========= */

  function initOne(widget) {
    if (!widget || widget.__qdwInit) return;     // avoid double-inits
    widget.__qdwInit = true;

    const thresholds = JSON.parse(widget.getAttribute('data-thresholds') || '[]')
      .sort((a, b) => a.min - b.min);

    const formatMoney = makeFormatter(widget);

    const els = {
      fill: widget.querySelector('.qdw-bar-fill'),
      label: widget.querySelector('.qdw-bar-label'),
      current: widget.querySelector('.qdw-current-label'),
      msg: widget.querySelector('.qdw-message'),
      subtotal: widget.querySelector('.qdw-subtotal'),
      saveRow: widget.querySelector('.qdw-save-row'),
      save: widget.querySelector('.qdw-save'),
      total: widget.querySelector('.qdw-total')
    };

    const pct = v => Math.round((v || 0) * 100);

    function rateForQty(qty) {
      let r = 0;
      for (let i = 0; i < thresholds.length; i++) {
        if (qty >= thresholds[i].min) r = Math.max(r, thresholds[i].rate);
      }
      return r;
    }

    function nextTier(qty) {
      for (let i = 0; i < thresholds.length; i++) {
        if (qty < thresholds[i].min) return thresholds[i];
      }
      return null;
    }

    // Progress bar fill: equal steps across tiers (e.g., 4 tiers ⇒ 25% each)
    function fillPercent(qty) {
      if (!thresholds.length) return 0;
      if (qty < thresholds[0].min) return 0;
      let idx = -1;
      for (let i = 0; i < thresholds.length; i++) {
        if (qty >= thresholds[i].min) idx = i;
      }
      const step = 100 / thresholds.length;
      return Math.min(100, step * (idx + 1));
    }

    function update(cart) {
      const qty = Number(cart.item_count || 0);
      const sub = typeof cart.items_subtotal_price === 'number'
        ? cart.items_subtotal_price
        : Number(cart.total_price || 0);

      const rate = rateForQty(qty);
      const discount = Math.round(sub * rate);
      const discounted = sub - discount;

      // Progress visuals
      const fill = fillPercent(qty);
      if (els.fill) els.fill.style.width = fill + '%';
      if (els.label) els.label.textContent = pct(rate) + '%';
      if (els.current) els.current.textContent = (pct(rate) || 0) + '% discount applied';

      // Money lines
      if (els.subtotal) els.subtotal.textContent = formatMoney(sub);
      if (els.total) els.total.textContent = formatMoney(discounted);

      if (els.saveRow) {
        if (discount > 0) {
          els.saveRow.hidden = false;
          if (els.save) els.save.textContent = formatMoney(discount);
        } else {
          els.saveRow.hidden = true;
          if (els.save) els.save.textContent = formatMoney(0);
        }
      }

      // Message under the bar
      const nxt = nextTier(qty);
      if (els.msg) {
        if (!nxt) {
          els.msg.textContent = `🎉 You save ${formatMoney(discount)}. You’re at the max ${pct(rate)}% discount.`;
        } else {
          const more = Math.max(0, nxt.min - qty);
          els.msg.textContent = `You save ${formatMoney(discount)} — add ${more} more item${more === 1 ? '' : 's'} to reach ${pct(nxt.rate)}% discount.`;
        }
      }
    }

    // First paint from Liquid data attributes (fast, no network)
    update({
      item_count: Number(widget.getAttribute('data-cart-qty') || 0),
      items_subtotal_price: Number(widget.getAttribute('data-cart-subtotal') || 0)
    });

    // Shared refresher
    const refresh = () =>
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(update)
        .catch(() => {});

    // Hook common cart events
    document.addEventListener('cart:updated', refresh);
    document.addEventListener('cart:refresh', refresh); // some themes use this

    // Quantity inputs / +/- buttons
    document.addEventListener('change', (e) => {
      const n = e.target && e.target.name;
      if (n === 'updates[]' || n === 'quantity') setTimeout(refresh, 150);
    });
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-quantity-plus]') || e.target.closest('[data-quantity-minus]')) {
        setTimeout(refresh, 200);
      }
    });

    // Gentle polling—helps themes that don’t emit events
    let iv = setInterval(refresh, 4000);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { clearInterval(iv); iv = null; }
      else if (!iv) { iv = setInterval(refresh, 4000); }
    });
  }

  /* ========= Bootstrap ========= */

  // Init now, and again after first async cart/totals paint
  document.addEventListener('DOMContentLoaded', () => {
    initAll();
    setTimeout(() => {
      // re-sync once after theme’s first AJAX subtotal update
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(() => initAll())
        .catch(() => {});
    }, 300);
  });

  // Re-init when Shopify re-renders sections (drawer, cart footer, etc.)
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', initAll);
  document.addEventListener('shopify:section:select', initAll);
  document.addEventListener('shopify:section:deselect', initAll);

  // As a catch-all, watch DOM for injected nodes (AJAX cart/drawer)
  new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });
})();
